import { render, staticRenderFns } from "./ChildModal.vue?vue&type=template&id=5bf91fdc&scoped=true"
import script from "./ChildModal.vue?vue&type=script&lang=js"
export * from "./ChildModal.vue?vue&type=script&lang=js"
import style0 from "./ChildModal.vue?vue&type=style&index=0&id=5bf91fdc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf91fdc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalCloseButton: require('/vercel/path0/components/ModalCloseButton.vue').default})
